import SignupSponsorConfirm from './container'

export default SignupSponsorConfirm
